import React from "react";
import { Outlet } from "react-router-dom";
import useHeaderPortal from "../../config/contexts/HeaderPortalContext";
import PendingCalls from "./components/PendingCalls";

const Dialer = () => {
  useHeaderPortal(() => <PendingCalls/>);
  return <Outlet />;
};

export default Dialer;
